import { CreateParagraph, OptionsParagraph } from "./paragraph";
import { CreateRpr } from "./rpr";

interface OptionsNumPr extends OptionsParagraph {
    /** Format. Default as %1. for the first level, %2. for second level... */
    format?: string;
    /** Indentations: twips value */
    indentation?: {
        /** Default as 360 */
        hanging?: number;
        /** Default as 720 times the list level */
        left?: number;
    };
    /** Justification. Default as left */
    justification?: string;
    /** Paragraph style. Default as ListParagraph */
    pStyle?: string;
    /** Start value. Default as 1 */
    start?: number;
    /** Suffix */
    suff?: "space" | "tab";
    /** Type: decimal, bullet, upperRoman, lowerRoman, upperLetter, lowerLetter, ordinal, cardinalText, ordinalText, none... */
    type: string;
}

/**
 * Create paragraph
 */
class CreateNumpr {
    /**
     * Element options
     */
    protected options: OptionsNumPr[];

    /**
     * Constructor
     *
     * @param options - Options list
     */
    constructor(options: OptionsNumPr[]) {
        const defaultBullets = ["", "o", "", "", "o", "", "", "o", ""];
        const defaultBulletsFonts = [
            "Symbol",
            "Courier New",
            "Wingdings",
            "Symbol",
            "Courier New",
            "Wingdings",
            "Symbol",
            "Courier New",
            "Wingdings",
        ];

        // set default values
        options.forEach((option, index) => {
            if (option.format == null) {
                if (option.type == "bullet") {
                    option.format = defaultBullets[index];
                    option.font = defaultBulletsFonts[index];
                } else {
                    option.format = "%" + (index + 1) + ".";
                }
            }

            if (option.indentation == null) {
                option.indentation = { hanging: 360, left: 720 * (index + 1) };
            } else {
                if (option.indentation.hanging == null) {
                    option.indentation.hanging = 360;
                }
                if (option.indentation.left == null) {
                    option.indentation.left = 720 * (index + 1);
                }
            }

            if (option.justification == null) {
                option.justification = "left";
            }

            if (option.start == null) {
                option.start = 1;
            }

            options[index] = option;
        });

        this.options = options;
    }

    /**
     * Creates content
     *
     * @returns List style
     */
    public create(): string {
        let contents =
            '<w:abstractNum w:abstractNumId="" xmlns:w="http://schemas.openxmlformats.org/wordprocessingml/2006/main"><w:multiLevelType w:val="hybridMultilevel"/>';

        this.options.forEach((option, index) => {
            contents += '<w:lvl w:ilvl="' + index + '">';
            contents += '<w:start w:val="' + option.start + '"/>';
            contents += '<w:numFmt w:val="' + option.type + '"/>';
            if (option.suff != null) {
                contents += '<w:suff w:val="' + option.suff + '"/>';
            }
            contents += '<w:lvlText w:val="' + option.format + '"/>';
            contents += '<w:lvlJc w:val="' + option.justification + '"/>';

            const pPrElement = new CreateParagraph(option);
            contents += pPrElement.createPpr();
            const rPrElement = new CreateRpr(option);
            contents += rPrElement.create();

            contents += "</w:lvl>";
        });

        contents += "</w:abstractNum>";

        return contents;
    }
}

export { CreateNumpr, OptionsNumPr };
